window.Visualizations.Tables.AjaxTable = {
  rerender(htmlID, newHtml) {
    const element = document.getElementById(htmlID);
    if (element) element.innerHTML = newHtml;
  }
};
